var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn md__btn-link bgt p-0 m-0",on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.icoSrc,"alt":"","width":"24"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }